export const envistate = {
    faqs: [
      {
        question: "What is my system health today?",
      },
      {
        question: "Give me a list of critical servers.",
      },
      {
        question: "Have there been any recent anomalies detected?",
      },
      {
        question: "What is the current CPU usage across all servers?",
      },
    ],
    // Add other company-specific contents here
    // For example: policies, guidelines, resources, etc.
    policies: [
      // ...policy objects
    ],
    guidelines: [
      // ...guideline objects
    ],
    // etc.
  };